import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {MainSearchComponent} from "./components/main-search/main-search.component";
import {OptionsService} from "@services/options-service.service";
import {Http404Component} from "./components/http404/http404.component";

const routes: Routes = [
  {path:"", component:MainSearchComponent, resolve:{options:OptionsService}},
  {path:"**", component:Http404Component}
];

@NgModule({
  imports:[RouterModule.forRoot(routes)],
  exports:[RouterModule]
})
export class AppRoutingModule {
}
